// extracted by mini-css-extract-plugin
export var button = "HeaderTabs-module--button--nNlyz";
export var component = "HeaderTabs-module--component--Z0J7Z";
export var isActive = "HeaderTabs-module--isActive--jGLAq";
export var list = "HeaderTabs-module--list--MxJx3";